export default __webpack_public_path__ + "static/gallery-art-expanded-72fa2e5506b0d58c45931f343fc6bee0.jpg";